import React from "react";
import YearbookSearchCard from "./yearbookSearchCard/yearbookSearchCard";
import "./yearbookSearchList.scss";

const YearbookSearchList = ({props}) => {

    const { data } = props;

    return(
        <>
            <div id="results">
                <div className="row">
                    <div className="col-md-12">
                        <div className="search-results">
                            <div className="search-results-body">
                                {
                                    data?.items.map((result, index) => {
                                        return <YearbookSearchCard props={result}/>
                                    })
                                }
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default YearbookSearchList;
